export default __webpack_public_path__ + "static/media/Hana_Icon.d5860283.png";